<template>
  <div class="location-selector">
    <form-item
      label="Search Location"
      class="label"
    >
      <location-picker
        class="location-picker"
        :options="locationOptions"
        :value="selectedLocation"
        @selected="locationSelected"
      />
    </form-item>
    <button
      class="search-broadcasts-button"
      :disabled="!queryLocation"
      @click="$emit('search', selectedLocation)"
    >
      <span>Search Broadcasts</span>
    </button>
    <custom-location-modal
      ref="customLocation"
      class="custom-location-modal"
      close-button
    />
  </div>
</template>

<script>
import { LocationSelectionMixin } from '@ibiquity/dashboard.location-selector';
import FormItem from '@/components/common/FormItem';
import CustomLocationModal from './_CustomLocationModal';
import LocationPicker from './_LocationPicker';

export default {
  name: 'LocationSelection',
  components: {
    FormItem,
    LocationPicker,
    CustomLocationModal,
  },
  mixins: [
    LocationSelectionMixin,
  ],
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selectedLocation = this.value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";
@import "~@/assets/scss/mixins";
@import "~@/assets/scss/buttons";

.location-selector {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.location-picker {
  width: 100%;
}

.label {
  width: 100%;
  margin: 0;
  max-width: 491px;

  @include from($tablet) {
    margin-right: 24px;
  }

  @include until($mobile) {
    margin-right: 0;
  }
}

.search-broadcasts-button {
  @include button($orange, $orange, $white);
  height: 50px;
  width: 200px;
  margin-top: 19px;
  flex: 0 0 auto;

  @include until($tablet) {
    width: 100%;
  }
}
</style>
